import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ContratoSelecionarFormaPagamentoModule, FooterModule, HeaderModule } from '@usucampeao/ui-mobile';
import { DetalhesSuperSocialModule } from 'libs/ui-mobile/src/lib/pages/cadastros-novo/detalhes-super-social/detalhes-super-social.module';
import { ConfirmarSolicitacaoSuperSocialRoutingModule } from './confirmar-solicitacao-super-social-routing.module';
import { ConfirmarSolicitacaoSuperSocialPage } from './confirmar-solicitacao-super-social.page';

@NgModule({
  declarations: [
    ConfirmarSolicitacaoSuperSocialPage
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,
    FormsModule,
    // route
    ConfirmarSolicitacaoSuperSocialRoutingModule,
    // components
    ContratoSelecionarFormaPagamentoModule,
    DetalhesSuperSocialModule,
    HeaderModule,
    FooterModule,
  ]
})
export class ConfirmarSolicitacaoSuperSocialPageModule { }
